// import React, { useEffect, useState } from 'react';
// import Header from '../Header/Header';
// import Footer from '../Footer/Footer';
// import '../../App.css';
// import A1 from '../Images/Wat1.jpg';
// import l1 from '../Images/H1.png';
// const Home = () => {
//     const [animateText, setAnimateText] = useState(false);

//     useEffect(() => {
//         setTimeout(() => {
//             setAnimateText(true);
//         }, 500);
//     }, []);

//     return (
//         <>
//             <Header />
//             <div className={`home-container ${animateText ? 'animate' : ''}`}>
//                 <div className="text-container">
//                     <h1 style={{ fontSize: '46px', marginBottom: '10px', color: '#29308a' }}><strong> <img src={l1} alt="Logo" className="logo-img" style={{ width: '40px' }} />
//                         Grow your business</strong></h1>
//                     <h2 style={{ fontSize: '44px', color: '#003142', marginBottom: '15px' }}><strong>on WhatsApp</strong></h2>
//                     <p>
//                         Personalize communication and sell more with the<br />
//                         WhatsApp Business API platform that automates<br />
//                         marketing, sales, service, and support.
//                     </p>
//                 </div>
//                 <img src={A1} alt="WhatsApp Business" className="logo-img1" />
//             </div>
//             <Footer />
//         </>
//     );
// };

// export default Home;


import React, { useEffect, useState } from 'react';
import l1 from '../Images/Chatbot.jpeg';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import '../../App.css';
import A1 from '../Images/aa.png';
import H1 from '../Images/H1.png';

const Home = () => {
    const [animateText, setAnimateText] = useState(false);
    const [demoFlows, setDemoFlows] = useState([]);
    const [showFlows, setShowFlows] = useState(false);

    const fetchflowconfig = () => {
        fetch('https://rvapi.emedha.in/pages/api/api/eflowconfig')
            .then((response) => response.json())
            .then((data) => {
                setDemoFlows(data);
            })
            .catch((error) => {
                console.error('Error fetching demo flows:', error);
            });
    };

    const handleImageClick = () => {
        if (!showFlows) {
            fetchflowconfig();
        }
        setShowFlows(!showFlows);
    };

    useEffect(() => {
        setTimeout(() => {
            setAnimateText(true);
        }, 500);
    }, []);

    useEffect(() => {
        fetchflowconfig();
    }, []);


    const [selectedFlow, setSelectedFlow] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [mobileNumber, setMobileNumber] = useState('');

    const handleSubmit = () => {
        if (selectedFlow) {
            const url = `https://emedha.com/echatbot/send_flow.php?id=${selectedFlow.id}&mobile=${mobileNumber}`;
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    alert('Check your WhatsApp for further instructions.');
                    setIsModalOpen(false);
                })
                .catch(error => {
                    console.error('Error sending flow:', error);
                    alert('There was an error processing your request.');
                });
        }
    };

    const handleFlowClick = (flow) => {
        setSelectedFlow(flow);
        setIsModalOpen(true);
    };

    return (
        <>
            <Header />
            <div className={`home-container ${animateText ? 'animate' : ''}`}>
                <div className="text-container">
                    <h1 className='me-5' style={{ fontSize: '46px', marginBottom: '10px', color: '#29308a' }}>
                        <strong>
                             <img src={H1} alt="H1" className="h1-image" />Grow your business <br />
                        </strong>
                        <strong style={{ fontSize: '44px', color: 'green', marginBottom: '15px', paddingLeft: "80px" }}>
                            on WhatsApp
                        </strong>
                    </h1>
                    <p className='text-black' style={{ paddingLeft: "80px" }}>
                        Personalize communication and sell more with the<br />
                        WhatsApp Business API platform that automates<br />
                        marketing, sales, service, and support.
                    </p>
                </div>
                <div>
                    <img src={A1} alt="WhatsApp Business" className="logo-img1" />
                </div>
            </div>


            <div style={{ position: 'relative' }}>
                <img src={l1} alt="Logo" className="logo-img" style={{ width: '80px', position: 'fixed', bottom: '30px', right: '30px', zIndex: '10', borderRadius: '50%', cursor: 'pointer', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', transition: 'transform 0.3s ease-in-out', }} onClick={handleImageClick} onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'} onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'} />
                {showFlows && (
                    <div style={{ position: 'fixed', bottom: '120px', right: '30px', zIndex: '10' }}>
                        {demoFlows.map((flow) => (
                            <div key={flow.id} style={{ marginBottom: '10px' }}>
                                <button
                                    onClick={() => handleFlowClick(flow)}
                                    style={{ width: '220px', padding: '10px', fontSize: '14px', backgroundColor: '#003142', color: 'white', border: 'none', borderRadius: '25px', cursor: 'pointer', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', transition: 'background-color 0.3s, transform 0.2s', }}
                                    onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#45a049'; e.currentTarget.style.transform = 'scale(1.05)'; }}
                                    onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#4CAF50'; e.currentTarget.style.transform = 'scale(1)'; }}
                                >
                                    {flow.display_name}
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {isModalOpen && (
                <div className="modal" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
                    <div className="modal-content" style={{ backgroundColor: 'white', padding: '30px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', width: '90%', maxWidth: '400px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
                        <span className="close" onClick={() => setIsModalOpen(false)} style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '24px', cursor: 'pointer', color: '#333' }}>&times;</span>
                        <h2>Enter Your Mobile Number</h2>
                        <input type="text" placeholder="Enter mobile number" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} style={{ padding: '12px 20px', fontSize: '16px', width: '100%', maxWidth: '300px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: '5px', outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.3s ease' }} />
                        <button onClick={handleSubmit} style={{ padding: '12px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '16px', width: '100%', maxWidth: '300px', transition: 'background-color 0.3s ease' }}>Submit</button>
                    </div>
                </div>
            )}
            <Footer />
        </>
    );
};

export default Home;


